import React, { useEffect, useRef } from 'react';
import L from 'leaflet';

const SimpleMap = ({
  latitude,
  longitude,
  size,
}: {
  latitude: number;
  longitude: number;
  size: string;
}) => {
  const mapRef = useRef(null);

  useEffect(() => {
    if (mapRef.current) {
      const map = L.map(mapRef.current, {
        scrollWheelZoom: false,
      }).setView([latitude, longitude], 13);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map);

      L.marker([latitude, longitude]).addTo(map);
    }
  }, [latitude, longitude]);

  return <div ref={mapRef} style={{ height: size, width: size }} />;
};

export default SimpleMap;
